module.exports = __webpack_public_path__ + "static/media/AvenirNext-Italic.9138c6e5.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/AvenirNext-Italic.woff
// module id = 76
// module chunks = 0